export default __webpack_public_path__ + "static/media/Sage's Cover of Shimmering Light.bcc5a486.jpg";